module.exports = __webpack_public_path__ + "img/zip.a5dbdf84.jpg";